import { createShipperHttpClient } from '../infra/createShipperHttpClient'
import { ShipperRepository } from '../infra/ShipperRepository'

export type DeleteShipperAttachmentParams = {
  shipperUuid: string
  attachmentId: number
}

export type DeleteShipperAttachmentFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function deleteShipperAttachmentFactory({
  shipperRepository,
}: DeleteShipperAttachmentFactoryDependencies) {
  return async function (
    params: DeleteShipperAttachmentParams,
    config?: { signal?: AbortSignal }
  ): Promise<void> {
    return shipperRepository.deleteShipperAttachment(
      params.shipperUuid,
      params.attachmentId,
      config
    )
  }
}

export function deleteShipperAttachment(
  params: DeleteShipperAttachmentParams,
  config?: { signal?: AbortSignal }
): Promise<void> {
  const httpClient = createShipperHttpClient()
  const shipperRepository = new ShipperRepository({ httpClient })
  const deleteFn = deleteShipperAttachmentFactory({ shipperRepository })
  return deleteFn(params, config)
}
